import { render, staticRenderFns } from "./Mails.vue?vue&type=template&id=856c9d70&scoped=true&"
import script from "./Mails.vue?vue&type=script&lang=js&"
export * from "./Mails.vue?vue&type=script&lang=js&"
import style0 from "./Mails.vue?vue&type=style&index=0&id=856c9d70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856c9d70",
  null
  
)

export default component.exports